import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  style: {
    "background-color": "#f7f7f7"
  }
};
const _hoisted_2 = {
  class: "news-content"
};
const _hoisted_3 = {
  style: {
    "padding": "0 10px"
  }
};
import FriendLink from "@/views/components/friendLink.vue";
import { breadCrumb } from '@/utils/dic';
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import { getProvincesDetail, getServiceList, getServiceTabs } from '@/api/home';
import { getCurrentInstance, ref } from 'vue';
import { tableProps } from "./serviceGuideConfig";
export default {
  __name: 'serviceGuide',
  setup(__props) {
    const provinceInfo = JSON.parse(sessionStorage.getItem('provinceInfo')) || {};
    const {
      proxy
    } = getCurrentInstance();
    let queryParams1 = ref({});
    let businessSysRecords = ref([]);
    let operationLinks = ref([]);
    let friendlyLinks = ref([]);
    let activeName = ref('tab0');
    const route = useRoute();
    let breadName = ref('');
    getProvinceEntranceInfo();
    // watch(() => route.query.type, (val) => {
    //   val ? breadName.value = breadCrumb[val].name : breadName.value = ''
    //   proxy.$nextTick(() => {
    //     handleSearch(val)
    //   })

    // }, {
    //   immediate: true
    // })
    const id = route.query.id;
    watch(() => activeName.value, val => {
      if (val) {
        console.log(val);
        proxy.$nextTick(() => {
          handleSearch({
            page: 1,
            size: 10,
            contentTypeCode: val,
            linkId: id
          }, true);
        });
      }
    });
    function emitAlink(data) {
      if (data.key === 'title') {
        const type = route.query.type;
        openInNewTab('/article', {
          id: data.rowData.id,
          type
        });
      }
    }
    const router = useRouter();
    function openInNewTab(path, query) {
      const url = router.resolve({
        path,
        query
      }).href;
      window.open(url, "_blank");
    }
    function handleSearch(data, isButtonSearch) {
      console.log('data', data);
      proxy.$refs.hTable1.getList(data, isButtonSearch);
    }
    let tabs = ref([]);
    function getTabs() {
      getServiceTabs({
        curlevel: false,
        lazy: false,
        parentCode: 'fwzn'
      }).then(res => {
        if (res.success) {
          tabs.value = res.data;
          activeName.value = tabs.value[0].contentTypeCode;
        } else {
          proxy.$message.error(res.message);
        }
      });
    }
    getTabs();
    function getProvinceEntranceInfo() {
      if (!provinceInfo.linkCode) {
        return;
      }
      getProvincesDetail({
        linkCode: provinceInfo.linkCode
      }).then(res => {
        if (res.success) {
          businessSysRecords.value = res.data.businessSysRecords;
          operationLinks.value = res.data.operationLinks;
          friendlyLinks.value = res.data.friendlyLinks;
        } else {
          proxy.$message.error(res.message);
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_hTable = _resolveComponent("hTable");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(Header), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "nav-link"
      }, [_createTextVNode("当前位置： "), _createElementVNode("a", {
        href: "/"
      }, "首页"), _createTextVNode(" > 服务指南")], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tabs, {
        modelValue: _unref(activeName),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(activeName) ? activeName.value = $event : activeName = $event),
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (item, index) => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            label: item.contentTypeName,
            name: item.contentTypeCode
          }, null, 8, ["label", "name"]);
        }), 256)), _createVNode(_component_hTable, {
          ref: "hTable1",
          tableProps: _unref(tableProps),
          queryParams: _unref(queryParams1),
          functionKey: "getServiceList",
          onAlink: emitAlink
        }, null, 8, ["tableProps", "queryParams"])]),
        _: 1
      }, 8, ["modelValue"])])]), _unref(friendlyLinks).length > 0 ? (_openBlock(), _createBlock(FriendLink, {
        key: 0,
        friendlyLinks: _unref(friendlyLinks)
      }, null, 8, ["friendlyLinks"])) : _createCommentVNode("", true)]), _createVNode(Footer)], 64);
    };
  }
};